import { render } from "./AppSlides.vue?vue&type=template&id=790a1bdd&scoped=true"
import script from "./AppSlides.vue?vue&type=script&lang=js"
export * from "./AppSlides.vue?vue&type=script&lang=js"

import "./AppSlides.vue?vue&type=style&index=0&id=790a1bdd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-790a1bdd"]])

export default __exports__